var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-grid"},_vm._l((_vm.images),function(image,index){return _c('img',{key:index,attrs:{"src":image},on:{"click":function($event){return _vm.$emit('selected', index)}}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b719ed4c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/offers-list/ImageGrid.vue
// module id = 700
// module chunks = 1